
import React from "react";
import "./DistanceEducation.css";
import Navbar from "../../components/Homepage/Navbar/Navbar";
import Footer from "../../components/Homepage/Footer/Footer";

const DistanceEducation = () => {
  return (
    <div className="distance-education-page">
      <Navbar />

      <div className="distance-container">
        <div className="page-header">
          <h1>Directorate of Distance Education</h1>
          <div className="header-underline"></div>
        </div>

        <div className="distance-director-card">
          <div className="distance-director-image">
            <img
              src="/person/RECTOR_NAIK.JPG"
              alt="Director, Directorate of Distance Education"
            />
          </div>

          <div className="distance-director-details">
            <h2>Director</h2>
            <h3>Prof. N. T. K. Naik</h3>
            <p>Directorate of Distance Education</p>
            <p>Rayalaseema University, Kurnool</p>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default DistanceEducation;
